module.exports = __webpack_public_path__ + "static/media/up.7d7eb4c0.svg";